import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { DataSource } from '@angular/cdk/collections';
import { FleetService } from '../../../services/fleet/fleet.service';
import { FleetdetailsComponent } from '../fleetdetails/fleetdetails.component';

@Component({
  selector: 'app-fleetlistview',
  templateUrl: './fleetlistview.component.html',
  styleUrls: ['./fleetlistview.component.scss']
})
export class FleetlistviewComponent implements OnInit {

  availableCount: number = 0;
  unavailableCount: number = 0;
  inplanningCount: number = 0;
  scheduledCount: number = 0;
  intransitCount: number = 0;
  typeOfOrder: any = 'available';
  mapView: boolean = false;
  columnsToDisplay = [
    'licenseNumber',
    'make',
    'model',
    'vType',
    'volume',
    'weight',
    'transporter',
    'driver'
  ];
  fleetDataArray = new MatTableDataSource;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isLoading: boolean = false;

  constructor(
    public dialog: MatDialog,
    public fleetService: FleetService,
  ) { }

  ngOnInit() {
    this.fleetService.getAllFleetsByStatus('FLEET_STATE_UNPLANNED').subscribe(res => {
      this.fleetDataArray.data = res;
    });

    this.fleetDataArray.paginator = this.paginator;

    this.fleetService.getFleetCountByStatus().subscribe(res => {
      console.log("fleet count by status", res);
      this.availableCount = this.searchArraryForCount(res, 'FLEET_STATE_UNPLANNED');
      this.unavailableCount = this.searchArraryForCount(res, 'FLEET_STATE_INITIAL');
      this.inplanningCount = this.searchArraryForCount(res, 'FLEET_STATE_IN_PLANNING');
      this.scheduledCount = this.searchArraryForCount(res, 'FLEET_STATE_SCHEDULED');
      console.log(this.searchArraryForCount(res, 'FLEET_STATE_INITIAL'))
      this.intransitCount = this.searchArraryForCount(res, 'FLEET_STATE_IN_TRANSIT');
    })

  }

  searchArraryForCount(arr, value) {
    for (let i = 0; i < arr.length; i++) {
      // console.log(arr[i])
      // console.log(value)
      // console.log(arr[i].fleetStatus == value)
      if (arr[i].fleetStatus == value) {
        return arr[i].fleetCount;
      }
    }
  }

  toogleView() {
    if (!this.mapView) {
      this.mapView = true;
      console.log(this.mapView);
    } else {
      this.mapView = false
      console.log(this.mapView);
    }
  }
  ngAfterViewInit() {
    this.fleetDataArray.paginator = this.paginator;
  }

  fleetData(type) {
    this.typeOfOrder = type;
    console.log(type);
    this.isLoading = true;
    this.fleetDataArray.data = [];
    switch (type) {

      case "available":
        this.getData('FLEET_STATE_UNPLANNED').subscribe(res => {
          this.fleetDataArray.data = res;
          this.isLoading = false;
          console.log(res);
        }, Error => {
          this.isLoading = false;
        });
        break;
      case "unavailable":
        this.getData('FLEET_STATE_INITIAL').subscribe(res => {
          this.fleetDataArray.data = res;
          this.isLoading = false;
        }, Error => {
          this.isLoading = false;
        });
        break;
      case "inplanning":
        this.getData('FLEET_STATE_IN_PLANNING').subscribe(res => {
          this.fleetDataArray.data = res;
          this.isLoading = false;
        }, Error => {
          this.isLoading = false;
        });
        break;
      case "scheduled":
        this.getData('FLEET_STATE_SCHEDULED').subscribe(res => {
          this.fleetDataArray.data = res;
          this.isLoading = false;
        }, Error => {
          this.isLoading = false;
        });
        break;
      case "intransit":
        this.getData('FLEET_STATE_IN_TRANSIT').subscribe(res => {
          this.fleetDataArray.data = res;
          this.isLoading = false;
        }, Error => {
          this.isLoading = false;
        });
        break;
      default:

    }
  }

  getData(type) {
    return this.fleetService.getAllFleetsByStatus(type);
  }

  fleetDetails(data) {
    let editDialog = this.dialog.open(FleetdetailsComponent, {
      width: '800px',
      data: { data: data }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
    editDialog.afterClosed().subscribe(result => {
      console.log(result);
    });
  }
}

export interface FleetListElement {
  licenseNumber: string,
  make: string,
  model: string,
  type: string,
  vType: string,
  weight: string,
  volume: string,
  transporter: string,
  driver: string
}